import { render } from "./RightSwiper.vue?vue&type=template&id=fff73d6c"
import script from "./RightSwiper.vue?vue&type=script&lang=js"
export * from "./RightSwiper.vue?vue&type=script&lang=js"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__